import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { LangContext } from "../LangContext.jsx";
class DossierDocumentsStats extends Component {
    static contextType = LangContext;
    constructor(props) {
        super(); 
    }
    render() {
        const { lang } = this.context; 
        return ( <div className="subheader pt-5 p-5 subheader-transparent d-flex flex-column card card-custom gutter-b" id="kt_subheader">
        <table className="table table-borderless m-0 table-valign text-center">
            <tbody>
                <tr className="b-bottom">
                    <td className="b-right"></td>
                    <td className="b-right">{lang.get('messages.por_cargar')}</td>
                    <td className="b-right">{lang.get('messages.por_firmar__por_revisar')}</td>
                    <td className="b-right">{lang.get('messages.aprobados')}</td>
                    <td className="b-right">{lang.get('messages.rechazados')}</td>
                    <td>{lang.get('messages.historial')}</td>
                </tr>
                <tr className="b-bottom">
                    <td  className="b-right text-left">{lang.get('messages.unicos')}</td>
                    <td  className="b-right"><b>{this.props.detail?.frequencyOnly.pending.length}</b></td>
                    <td  className="b-right">
                        <b>{this.props.detail ? this.props.detail?.frequencyOnly.loaded.length + this.props.detail?.frequencyOnly.pendingToSign.length : ''}</b>
                    </td>
                    <td  className="b-right"><b>{this.props.detail?.frequencyOnly.approved.length}</b></td>
                    <td  className="b-right"><b>{this.props.detail?.frequencyOnly.rejected.length}</b></td>
                    <td rowSpan="2"><b>{this.props.detail?.expired.documents.total_documents}</b></td>
                </tr>
                <tr>
                    <td  className="b-right text-left">{lang.get('messages.recurrentes')}</td>
                    <td  className="b-right"><b>{this.props.detail?.frequencyRecurrent.pending.length}</b></td>
                    <td  className="b-right"><b>{this.props.detail?.frequencyRecurrent.loaded.length}</b></td>
                    <td  className="b-right"><b>{this.props.detail?.frequencyRecurrent.approved.length}</b></td>
                    <td  className="b-right"><b>{this.props.detail?.frequencyRecurrent.rejected.length}</b></td>
                </tr>
            </tbody>
        </table>
    </div>);
    }
}

export default DossierDocumentsStats;

if (document.getElementById('DossierDocumentsStats')) {
    ReactDOM.render(<DossierDocumentsStats />, document.getElementById('DossierDocumentsStats'));
}
